import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { browserHistory } from 'react-router';
import { useSelector } from 'react-redux';
import useMenuRedirect from '../../hooks/useMenuRedirect';
import { DesktopMenuOption } from './components/DesktopMenuOption';
import { SearchItem } from '../SearchOption';
import './style.scss';
import { filterNodes } from '../../utils/filterNodes';
import { MenuAvatar } from 'containers/MenuAvatar';
import useNavControls from 'containers/Menu/hooks/useNavControls';

export const DesktopMenu = () => {
  const { nodes, nodesSelected, handleRedirect } = useMenuRedirect();
  const previousNodeSelected = useSelector(
    state => state.cvNavData?.navData?.previousSelected || {},
  );
  const [textNodesMaxWith, setTextNodesMaxWith] = useState('0');
  const [hasScrolled, setHasScrolled] = useState(false);

  const textNodesRef = useRef(null);
  const { pathname } = browserHistory.getCurrentLocation();
  const isSearchPath = pathname.includes('search');
  let appBehavior = nodesSelected?.app_behaviour || '{}';
  appBehavior = JSON.parse(appBehavior);
  const isNodeToShowPrevious =
    appBehavior?.layout === 'playandgo' ||
    appBehavior?.layout === 'filterbygenre';

  const getTextNodesMaxWidth = useCallback(
    () => {
      if (
        textNodesRef.current?.hasChildNodes() &&
        textNodesRef.current?.childNodes.length > 6
      ) {
        let maxWidthResult = 0;
        let flag = 0;

        for (const listItem of textNodesRef.current?.childNodes) {
          if (flag >= 6) break;
          flag += 1;
          maxWidthResult += listItem.offsetWidth;
        }
        return maxWidthResult;
      }

      return 'unset';
    },
    [nodes, textNodesRef.current],
  );

  useEffect(
    () => {
      setTextNodesMaxWith(getTextNodesMaxWidth());
    },
    [nodes, textNodesRef.current],
  );

  useLayoutEffect(() => {
    let timeout;

    const checkAndScroll = () => {
      const BUTTON_WIDTH = 96;
      const { scrollWidth, clientWidth } = textNodesRef.current ?? {};

      if (hasScrolled) return
      if (scrollWidth > clientWidth) {
        const allNodes = [...textNodesRef.current?.childNodes || []];
        const activeNodeIndex = allNodes.findIndex(node =>
          [...node.classList].includes('node-active') ||
          [...node.classList].includes('node-previous-active'),
        );
        const scrollOffset = allNodes.reduce((acc, current, i) => {
          if (i <= activeNodeIndex) {
            return acc + current.offsetWidth;
          }
          return acc;
        }, 0);

        if (activeNodeIndex >= 0) {
          textNodesRef.current.scrollLeft = activeNodeIndex > 1 ? scrollOffset - (BUTTON_WIDTH * 2) : 0;
          setHasScrolled(true)
          clearTimeout(timeout);
        }
      } else {
        timeout = setTimeout(checkAndScroll, 50);
      }
    };

    setTimeout(() => {
      checkAndScroll()
    }, 600);

    return () => clearTimeout(timeout);
  }, [nodesSelected, hasScrolled]);



  const isSubMenuSelectedFun = (nodesSelected) => {
    const navMainNodes = filterNodes(nodes);
    const matchNodes = navMainNodes?.filter((node) => node?.code === nodesSelected);
    const isSubMenu = matchNodes?.length < 1;
    return isSubMenu;
  };
  const isSubMenuSelected = isSubMenuSelectedFun(nodesSelected?.code);
  const prevSelected = window.sessionStorage.getItem('prevSelected');
  const menuRef = useRef(null)
  const {
    LetfButton,
    RightButton
  } = useNavControls(textNodesRef, menuRef, nodes)

  return (
    <ul className="desktop-menu" ref={menuRef}>
      <SearchItem isActive={isSearchPath} />
      <LetfButton />
      <div className="desktop-menu__text-nodes" ref={textNodesRef}>
        {nodes &&
          filterNodes(nodes).map(node => (
            <DesktopMenuOption
              key={`menu-node-${node.code}`}
              node={node}
              isActive={nodesSelected.code === node.code && !isSearchPath}
              isPreviousActive={node.code === prevSelected}
              onClick={() => {
                handleRedirect({ node });
              }}
            />
          ))}
      </div>
      <RightButton />

      <MenuAvatar />
    </ul>
  );
};

